import React from "react";
import { useLocation } from "react-router-dom";
import styles from "./ProductsCategory.module.css";

const ProductsCategory = ({
  title,
  image,
  color,
  href,
  handleClick,
  status,
  category,
  selectedCategories,
  categoryId,
}) => {
  const location = useLocation(); // Get the current route

  const handleLinkClick = (event) => {
    if (handleClick) {
      event.preventDefault(); // Prevent default link behavior
      handleClick(category); // Pass category to the filter function
    }
  };
  const isSelected = selectedCategories?.includes(categoryId) || false;

  // Display only the first two words of the title
  const formattedTitle = title
    .split(" ")
    .slice(0, 2)
    .map((word, index) => (
      <React.Fragment key={index}>
        {word}
        {index < 1 && <br />}
      </React.Fragment>
    ));

  // Check if the user is on the category list page
  // const isCategoryPage = location.pathname.includes("/categories");
  // Check if the user is on the category list page or a specific category page
  const isCategoryPage =
    location.pathname.startsWith("/categories") ||
    location.pathname.startsWith("/categories/");
  const isProductPage = location.pathname.includes("/products");

  return (
    <a
      href={href}
      onClick={handleLinkClick}
      className={`product-category-container ${styles.productCategoryContainer}`}
    >
      {isCategoryPage ? (
        <div
          className={`products-category ${styles.productsCategory}`}
          style={{ backgroundColor: color }}
        >
          <div
            className={`products-category-title ${styles.productsCategoryTitle}`}
          >
            {title}
          </div>
          <img
            src={image}
            alt="Product"
            className={`image-product-category ${styles.imageProductCategory}`}
          />
        </div>
      ) : isProductPage ? (
        <div className={`category-div ${styles.categoryDiv}`}>
          <div
            className={`category-icon-div ${styles.categoryIconDiv} ${
              isSelected ? `category-selected ${styles.categorySelected}` : ""
            }`}
            style={{ backgroundColor: color }}
          >
            <img
              src={image}
              className={`icon-product-category ${styles.iconProductCategory}`}
              alt="Category Icon"
            />
          </div>
          <div className={`product-category-name ${styles.productCategoryName}`}>
            {formattedTitle}
          </div>
          {status === "HOT" && (
            <div className={`hot-status ${styles.hotStatus}`}>{status}</div>
          )}
          {status === "Trendy" && (
            <div className={`trendy-status ${styles.trendyStatus}`}>{status}</div>
          )}
        </div>
      ) : null}
    </a>
  );
};

export default ProductsCategory;

// const ProductsCategory = ({ title, image, color, href, handleClick ,status,category,selectedCategories}) => {
//   const handleLinkClick = (event) => {
//     if (handleClick) {
//       event.preventDefault(); // منع السلوك الافتراضي للرابط
//       handleClick(category); // تمرير الفئة إلى دالة التصفية
//     }
//   };

//     // Check if the category is selected
//     // const isSelected = selectedCategories.includes(category);
//     const isSelected = selectedCategories?.includes(category) || false;

//   // Display only the first two words of the title
//   const formattedTitle = title
//     .split(" ")
//     .slice(0, 2) // Keep only the first two words
//     .map((word, index) => (
//       <React.Fragment key={index}>
//         {word}
//         {index < 1 && <br />} {/* Add a line break after the first word */}
//       </React.Fragment>
//     ));

//   return (
//     <a href={href} onClick={handleLinkClick} className='product-category-container'>
//       {/* <div className="products-category" style={{ backgroundColor: color }}>
//         <div className="products-category-title">{title}</div>
//         <img src={image} alt="Product" className="image-product-category" />
//       </div> */}
//       <div className='category-div'>
//         <div className={`category-icon-div ${isSelected ? 'category-selected' : ''}`} style={{ backgroundColor: color }}>
//            <img src={image} className='icon-product-category'/>
//         </div>
//         <div className='product-category-name'>{formattedTitle}</div>
//         {status === "HOT" && <div className="hot-status">{status}</div>}
//         {status === "Trendy" && <div className="trendy-status">{status}</div>}
//       </div>
//     </a>
//   );
// };

// export default ProductsCategory
